import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core';
import Dialog from 'material-ui/Dialog';
import { DefaultButton, RadioButton } from '../../../../components/Buttons';
import { CardTitle } from 'material-ui/Card';
import ReserveItem from './ReserveItem';
import apiCall from '../../../../data/app/apiCall';
import CircularLoading from '../../../../components/CircularLoading';
import './styles.scss';

const CancelBackBtn = withStyles({
    root: {
        color: 'white',
        backgroundColor: '#ADADAD',
        borderColor: '#ADADAD',
        "&:hover": {
            backgroundColor: "#ADADAD"
        }
    },
})(DefaultButton);

const SaveApplyNextBtn = withStyles({
    root: {
        color: 'white',
        backgroundColor: 'rgba(0,150,136, 1)',
        borderColor: 'rgba(0,150,136, 1)',
        "&:hover": {
            backgroundColor: "#009688"
        },
        '&:disabled': {
            backgroundColor: 'rgba(0,150,136,0.4)',
            color: '#757575',
            borderColor: 'rgba(0,150,136,0.4)',
        },
    },
})(DefaultButton);

const ReserveLine = (props) => {
    const [openDialogue, setOpenDialogue] = useState(props.open);
    const [reserveLineList, setReserveLineList] = useState(props.data || {});
    const [originalFetchedData, setOriginalFetchedData] = useState(null);
    const [isCloseClicked, setCloseClicked] = useState(false);
    const [isSubmitted, setSubmitted] = useState(false);
    const [isSaveDisabled, setDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);


    // Add responsive width calculation
    const getDialogStyle = () => {
        const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 1366;

        let dialogWidth = 950;
        if (screenWidth < 600) {
            dialogWidth = screenWidth - 40; // Mobile
        } else if (screenWidth < 960) {
            dialogWidth = screenWidth - 80; // Tablet
        } else if (screenWidth < 1280) {
            dialogWidth = Math.min(screenWidth - 100, 900); // Small laptop
        } else if (screenWidth < 1600) {
            dialogWidth = Math.min(screenWidth - 120, 950); // HP/Mac laptops
        }

        return {
            maxWidth: '95vw',
            width: `${dialogWidth}px`,
            minWidth: '320px',
            maxHeight: '90vh',
            overflowY: 'auto',
            overflowX: 'hidden'
        };
    };

    const [dialogStyle, setDialogStyle] = useState(getDialogStyle());

    // Update dialog style on window resize
    useEffect(() => {
        const handleResize = () => setDialogStyle(getDialogStyle());
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Function to fetch fresh reserve line data
    const fetchFreshReserveLineData = async (bidSessionId, staffId, categoryId) => {
        if (!bidSessionId || !staffId || !categoryId) return;
        
        setIsLoading(true);
        try {
            const reservelinetypesUrl = `preferences/reserveline?bidsession_id=${bidSessionId}&staff_id=${staffId}&category_id=${categoryId}`;
            const response = await apiCall(reservelinetypesUrl);
            
            if (response.data && response.data.bidderReserveLines) {
                setReserveLineList(response.data.bidderReserveLines);
                setOriginalFetchedData(response.data.bidderReserveLines);
            }
        } catch (error) {
            console.error('Failed to fetch fresh reserve line data:', error);
            // Fallback to props data
            setReserveLineList(props.data || {});
            setOriginalFetchedData(props.data || {});
        } finally {
            setIsLoading(false);
            setDisabled(true); // Disable save button after fresh data loads
        }
    };

    function saveUpdatedList() {
        props.openReserveLineDialogue(false);
        props.reorderReserveline(reserveLineList);
        setOpenDialogue(false);
        setCloseClicked(false);
        setSubmitted(true);
    }

    const handleClose = () => {
        setOpenDialogue(false);
        setCloseClicked(!isCloseClicked);
        setSubmitted(false);
        props.openReserveLineDialogue(false);
        props.cancelMessage();
        setReserveLineList({ ...props.data });
    }

    useEffect(() => {
        // Handle dialog open/close
        if(openDialogue !== props.open){
            setOpenDialogue(props.open);
            
            // When dialog opens, fetch fresh data
            if (props.open && props.bidSessionId && props.staffId && props.categoryId) {
                fetchFreshReserveLineData(props.bidSessionId, props.staffId, props.categoryId);
            }
        }
    }, [props.open, props.bidSessionId, props.staffId, props.categoryId]);

    const sortedReserveLine = (reserveLine) => {
        setReserveLineList(reserveLine);
        setCloseClicked(false);
        setSubmitted(false)
        setDisabled(false)
    }

    const saveButton = [
        <CancelBackBtn
            className="logOutBtnNo"
            style={{ marginRight: 8 }}
            onClick={handleClose}
        >CANCEL</CancelBackBtn>,
        <SaveApplyNextBtn
            className="logOutBtnYes"
            onClick={saveUpdatedList}
            disabled={isSaveDisabled}
        >
            {isLoading ? 'LOADING...' : 'SAVE'}
        </SaveApplyNextBtn>
    ];
    return (
        <Dialog
            title={
                <div className="no-margin">
                    <CardTitle
                        title={props.title}
                        subtitle={props.subtitle}
                        className="reserve-line-title"
                    />
                </div>
            }
            actions={saveButton}
            modal={false}
            open={openDialogue}
            onRequestClose={handleClose}
            style={{ zIndex: 9999 }}
            contentStyle={dialogStyle} 
          >
            <div>
                {isLoading ? (
                    <CircularLoading />
                ) : (
                    <ReserveItem 
                        reserveLineData={reserveLineList}
                        sortedReserveLine={sortedReserveLine}
                        closeClicked={isCloseClicked}
                        isSubmitted={isSubmitted}
                        originalData={props.data}
                        isReserveLineTypeSaveFailed={props.isReserveLineTypeSaveFailed}
                    />
                )}
            </div>
        </Dialog>
    );
}
export default ReserveLine;